import { InjectionToken } from '@angular/core';

export interface GraphRenderConfig {
  minView: number;
  padding: number;
  statusColors: Record<string, string>;
  statusIconClasses: Record<string, string>;

  // Node-level icons
  nodeIconClasses: {
    summary: string;
    fallback?: string;
  };

  // Utility icons used in UI
  uiIcons: Record<string, string>;
}

export const DEFAULT_GRAPH_RENDER_CONFIG: GraphRenderConfig = {
  minView: 700,
  padding: 40,

  statusColors: {
    Greeting:'border-pink',
    SmallTalk:'border-blue',
    OutOfScoop:'border-neutral-slate',
    NoIntent: 'border-dark-light',
    MoreInformation: 'border-info-light',
    Running: 'border-warning',
    Success: 'border-success-light',
    Failed: 'border-danger-light'
  },

  statusIconClasses: {
    Greeting: 'bx bxs-smile',
    SmallTalk: 'bx bxs-chat',
    OutOfScoop: 'bx bx-block',
    MoreInformation: 'bx bx-question-mark',
    NoIntent: 'bx bx-minus-circle',
    Running: 'bx bx-time-five',
    Success: 'bx bx-check-shield',
    Failed:  'bx bx-x-circle'
  },

  nodeIconClasses: {
    summary: 'bx bx-message-square-dots',
    fallback: 'bx bx-help-circle'
  },

  uiIcons: {
    timer: 'bx bx-timer',
    time: 'bx bx-time',
    link:  'bx bx-link'
  }
};

export const GRAPH_RENDER_CONFIG = new InjectionToken<GraphRenderConfig>(
  'GRAPH_RENDER_CONFIG',
  { factory: () => DEFAULT_GRAPH_RENDER_CONFIG }
);
